/*
Monotype Foundry Platform API
Version 1.0.0

Definition: SalesReportDownloadRequest

Properties:
  exportType: string
  filter: object
  paging: object
  searchQuery: string
  sorting: object
*/

var SalesReportDownloadRequest = (function () {
  function validateSalesReportDownloadRequest (arg) {
    // Validate exportType
    if (arg.exportType && !(typeof arg.exportType === 'string')) {
      throw new Error('SalesReportDownloadRequest.exportType: Wrong type: Got \'' + (typeof arg.exportType) + '\', but expected: \'string\'')
    }
    // Validate filter
    if (arg.filter && !(typeof arg.filter === 'object')) {
      throw new Error('SalesReportDownloadRequest.filter: Wrong type: Got \'' + (typeof arg.filter) + '\', but expected: \'object\'')
    }
    // Validate paging
    if (arg.paging && !(typeof arg.paging === 'object')) {
      throw new Error('SalesReportDownloadRequest.paging: Wrong type: Got \'' + (typeof arg.paging) + '\', but expected: \'object\'')
    }
    // Validate searchQuery
    if (arg.searchQuery && !(typeof arg.searchQuery === 'string')) {
      throw new Error('SalesReportDownloadRequest.searchQuery: Wrong type: Got \'' + (typeof arg.searchQuery) + '\', but expected: \'string\'')
    }
    // Validate sorting
    if (arg.sorting && !(typeof arg.sorting === 'object')) {
      throw new Error('SalesReportDownloadRequest.sorting: Wrong type: Got \'' + (typeof arg.sorting) + '\', but expected: \'object\'')
    }
  }
  function buildSalesReportDownloadRequest (arg) {
    var SalesReportDownloadRequest = arg
    // Complete exportType
    // Expected Type: string
    SalesReportDownloadRequest.exportType = SalesReportDownloadRequest.exportType || ''
    // Complete filter
    // Expected Type: object
    SalesReportDownloadRequest.filter = SalesReportDownloadRequest.filter || {}
    // Complete paging
    // Expected Type: object
    SalesReportDownloadRequest.paging = SalesReportDownloadRequest.paging || {}
    // Complete searchQuery
    // Expected Type: string
    SalesReportDownloadRequest.searchQuery = SalesReportDownloadRequest.searchQuery || ''
    // Complete sorting
    // Expected Type: object
    SalesReportDownloadRequest.sorting = SalesReportDownloadRequest.sorting || {}
    return SalesReportDownloadRequest
  }
  return {
    validate: validateSalesReportDownloadRequest,
    build: buildSalesReportDownloadRequest
  }
})()

module.exports = SalesReportDownloadRequest
